import { View, Text } from 'react-native';
import styled from 'styled-components/native';

import { elRed } from '../../styles/colors';

export const preSale = 'blue';
export const activeSale = `green`;
export const postSale = `${elRed}`;

export const BoldText = styled(View)`
  display: flex;
  flex-direction: row;
`;

export const NameStatusLabel = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const NameLabel = styled(Text)`
  font-weight: bold;
  align-self: start;
`;

export const StatusLabel = styled(Text)`
  font-weight: bold;
  align-self: end;
`;

export const getStatusType = (status) => {
  switch(status) {
    case 'Future':
    case 'Building Run List':
    case 'Ready For Sale':
    case 'Pending':
      return preSale;
      break;
    case 'Pre-Bid':
    case 'Live':
    case 'Processing':
      return activeSale;
      break;
    case 'Closed':
      return postSale;
      break;
  }
}

export const getStatus = (status, tableType) => {
  switch(status) {
    case 'Future':
    case 'Building Run List':
    case 'Ready For Sale':
    case 'Pending':
      return tableType ? 'pre' : 'Upcoming';
      break;
    case 'Pre-Bid':
    case 'Live':
    case 'Processing':
      return tableType ? 'live' : 'Live';
      break;
    case 'Closed':
      return tableType ? 'post' : 'Post';
      break;
  }
}
